import { ReactNode } from 'react';

export type SideNavItem = {
  key: string;
  path: string;
  name: string;
  analyticsName?: string;
  testId?: string;
  icon?: ReactNode;
  matches?: string[];
  iconPlacement?: IconPlacement;
};

export enum IconPlacement {
  ICON_BEFORE = 'ICON_BEFORE',
  ICON_AFTER = 'ICON_AFTER',
}

export type SideNavSection = {
  title?: string;
  testId?: string;
  customState?: ReactNode;
  items: SideNavItem[];
};

export type SidebarNavigationProps = {
  label: string;
  testId?: string;
  sections: SideNavSection[];
  selectedKey?: string;
};
